<template>
  <div id="indexMap">
    <div style="display: flex;
    flex-direction: column;width: 100%;height: 100%">
      <div class="d-flex pl-2" style="float:right;display: block;padding-top: 0.2rem">
        <!--         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;">-->
        <!--           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">全景地图</span>-->
        <!--        </span>-->
        <!--        <el-button icon="el-icon-video-camera"  @click="dialogVisible=true" class="float-r" ></el-button>-->
        <!--        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">-->
        <!--          <iframe  height="100%" width="100%" style="border:none" v-if="dialogVisible" allowfullscreen="true"-->
        <!--              src="https://www.96koo.net/videoPlayer.html?videoId=87521184d19b4b35511153f97eb1e636">-->
        <!--          </iframe>-->
        <!--        </el-dialog>-->

      </div>
      <div class="d-flex jc-center band" style="width: 100%;height:100%;padding-top: 0.1rem">
        <Echart
            id="MapChart3"
            ref="Map"
            :options="options"
            height="100%"
            width="100%"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart';

export default {
  data() {
    return {
      options: {},
      myChart: null,
      dialogVisible: false,
    };
  },
  components: {
    Echart
  },
  computed: {
    cdata() {
      return this.$store.state.cdata
    },
  },
  mounted() {
    this.mapBox()
    // window.addEventListener("resize",function(){
    //   this.myChart.resize();})
  },
  methods: {
    //地图样式
    mapBox() {
      let vm = this
      // var datalist = this.cdata
      // var geoCoordMap = {
      //   '科创中心': [106.054948,
      //     29.839944],
      // }
      var Data = [
        [
          {
            name: '易智网'
          },
          // {
          //   name: "科创中心",
          //   value: 99
          // },

        ]
      ]
      // var Bata=[
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "渝中区",
      //     value:100
      //   }],
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "江北区",
      //     value: 100
      //   }],
      //   [{
      //     name: '渝中区'
      //   }, {
      //     name: "沙坪坝区",
      //     value: 100
      //   }],
      // ]
      // var planePath = 'path://M895.616384 347.812188q0 10.22977-0.511489 19.436563t-1.534466 19.436563q-9.206793 84.907093-37.338661 163.164835t-71.096903 150.377622-99.228771 138.613387-121.734266 127.872128q-9.206793 11.252747-23.528472 11.252747-15.344655 0-24.551449-11.252747-65.470529-61.378621-122.245754-128.895105t-100.251748-141.170829-71.608392-152.935065-36.315684-165.210789q0-8.183816-0.511489-15.344655t-0.511489-15.344655q0-71.608392 28.131868-135.032967t76.211788-110.481518 113.038961-74.677323 138.613387-27.62038 138.101898 27.62038 112.527473 74.677323 76.211788 110.481518 28.131868 135.032967zM540.643357 507.396603q33.758242 0 63.424575-12.787213t51.66034-34.26973 34.781219-50.637363 12.787213-61.89011-12.787213-61.89011-34.781219-50.637363-51.66034-34.26973-63.424575-12.787213-63.424575 12.787213-52.171828 34.26973-35.292707 50.637363-12.787213 61.89011 12.787213 61.89011 35.292707 50.637363 52.171828 34.26973 63.424575 12.787213z';
// var iconR='image://data:image/gif;base64,R0lGODlhEAAQAMQAAORHHOVSKudfOulrSOp3WOyDZu6QdvCchPGolfO0o/XBs/fNwfjZ0frl3/zy7////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAkAABAALAAAAAAQABAAAAVVICSOZGlCQAosJ6mu7fiyZeKqNKToQGDsM8hBADgUXoGAiqhSvp5QAnQKGIgUhwFUYLCVDFCrKUE1lBavAViFIDlTImbKC5Gm2hB0SlBCBMQiB0UjIQA7'
      // var convertData = function (data) {
      //   var res = [];
      //   for (var i = 0; i < data.length; i++) {
      //     var dataItem = data[i];
      //     var fromCoord = geoCoordMap[dataItem[0].name];
      //     var toCoord = geoCoordMap[dataItem[1].name];
      //     if (fromCoord && toCoord) {
      //       res.push([{
      //         coord: fromCoord
      //       }, {
      //         coord: toCoord
      //       }]);
      //     }
      //   }
      //   return res;
      // };

      var series = [];
      [['',Data]].forEach(function (item) {
        console.log(item[0],'item')
        series = [{
          name: item[0].name,
          type: 'scatter',
          coordinateSystem: 'geo',
          symbolSize: '20',
          showEffectOn:'render',
          // symbol:planePath,
          // rippleEffect: { //坐标点动画
          //   brushType: iconR,
          //   scale: 5,
          //   color: '#ffa022'
          // },
          label: {
            normal: {
              show:false,
              position: 'right',
              formatter: '{b}',
            }
          },
          itemStyle: {
            show: false,
            normal: {
              color: '#fff',
              fontSize: 16
            },
            emphasis: {
              show: false,
              areaColor: '#045ada',
              borderColor: '#5cd9e8',
              textStyle: {
                color: '#fff',
                fontSize: 18
              },
            }
          },
          // data:geoCoordMap[item[0].name].concat([item[0].value])
          data: []
          //     item[1].map(function (dataItem) {
          //   return {
          //     name: dataItem[1].name,
          //     value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value]),
          //   };
          // })
        }]
      });
      let options = {
        showLegendSymbol: true,
        tooltip: {
          show: true,
          trigger: 'item',
          backgroundColor: '#efefef',
          textStyle: {
            color: '#4c9bfd',
            fontSize: 18
          },
          // formatter: "{b}<br>{c}",
          // position: point => {
          //   // 固定在顶部
          //   return [point[0] + 50, point[1] - 20];
          // },
          // //如果需要自定义 tooltip样式，需要使用formatter
          // formatter: params => {
          //   `<div id="plan">
          // <h4 style="margin:16px;font-size:18px;font-weight:normal;color:#fff;">${params.name}</h4>
          // <ul style="margin:16px;color:#fff;">
          // <li style="color:rgba(201,201,201,0.7);font-size:12px"><span>高企：</span>   <span style="color:#439aff;font-size:18px">${params.data.highTechFirm}</span><span>家</span></li>
          // </ul>
          // </div>`
          // },
          // formatter: '{b}<br/>企业{c}家'
        },
        geo: {
          map: '重庆市',
          type: 'map',
          mapType: '重庆市',
          layoutCenter: ['50%', '50%'],
          layoutSize: '100%',
          aspectScale: 1,
          zoom:1.05,
          roam: false,
          label: {
            normal: {
              show: true,
              color: '#fff',
              position: 'center',
            },
            emphasis: {
              show: true,
              color: '#fff',

              // textStyle: {
              //
              //   fontSize: 18
              // },
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#1098d6',
              borderColor: '#142957',
              borderWidth: 1
            },
            emphasis: {
              show: true,
              areaColor: '#045ada',
              borderColor: '#5cd9e8',
              borderWidth: 1,
              textStyle: {
                color: '#fff',
                fontSize: 14
              },
            }
          }

        },
        series: series
      };
      this.myChart = this.$echarts.init(document.getElementById('MapChart3'))
      this.myChart.setOption(options, true);
      //点击地图
      this.myChart.on("click", function (params) {
        vm.typeList = params
        //传值给主屏
        vm.$store.commit('setypeList3', vm.typeList)

        vm.myChart.dispatchAction({
          type: 'mapUnSelect',
          seriesIndex: 0,
          dataIndex: vm.preSelectMapIndex,
        });
        vm.myChart.dispatchAction({
          type: 'mapSelect',
          seriesIndex: 0,
          dataIndex: params.dataIndex,
        });
        vm.preSelectMapIndex = params.dataIndex;
      });

    }
  }
};
</script>

<style lang="scss">
.band {
  flex: 1;
}

// .el-dialog__body {
//   padding: 10px !important;
//   height: 100%!important;
// }

// .el-dialog__header {
//   padding: 0!important;
// }
// .el-button{
//   padding: 5px!important;
// }
.el-icon-video-camera{
  font-size: 24px!important;
}
#indexMap {
  height: 100%;
  width: 100%;
  //border-radius: 0.0625rem;
  //.bg-color-black {
  //  height: 4.8125rem;
  //  border-radius: 0.125rem;
  //}
  .text {
    color: #c3cbde;
  }

  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>